module.exports = __webpack_public_path__ + "components/rewards/freefloski/static/logo-a5935163ba3a929586548e52f3bcc0cf.webp";